import { DOCUMENT } from '@angular/common';
import { ApplicationRef, ComponentRef, createComponent, EnvironmentInjector, inject, Injectable } from '@angular/core';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { SzWhatsNewDialogComponent } from './sz-whats-new-dialog.component';
import { SzWhatsNewDialogData } from './sz-whats-new-dialog.types';

const CLOSE_ANIMATION_MS: number = 280;

@Injectable({ providedIn: 'root' })
export class SzWhatsNewDialogService {
  private readonly appRef: ApplicationRef = inject(ApplicationRef);
  private readonly envInjector: EnvironmentInjector = inject(EnvironmentInjector);
  private readonly document: Document = inject(DOCUMENT);

  // Otwiera modal „Co nowego". Strumień emituje raz (i kończy się) po zamknięciu -
  // niezależnie czy przez CTA, scrim czy Esc.
  open$(data: SzWhatsNewDialogData): Observable<void> {
    return new Observable<void>((subscriber: Subscriber<void>): (() => void) => {
      const ref: ComponentRef<SzWhatsNewDialogComponent> = createComponent(SzWhatsNewDialogComponent, {
        environmentInjector: this.envInjector
      });

      ref.setInput('title', data.title);
      ref.setInput('changes', data.changes);
      ref.setInput('ctaLabel', data.ctaLabel);

      this.appRef.attachView(ref.hostView);
      this.document.body.appendChild(ref.location.nativeElement);

      Promise.resolve().then((): void => ref.setInput('open', true));

      let destroyed: boolean = false;
      const teardown = (): void => {
        if (destroyed) return;
        destroyed = true;
        this.appRef.detachView(ref.hostView);
        ref.destroy();
      };
      const close = (): void => {
        ref.setInput('open', false);
        setTimeout((): void => {
          subscriber.next();
          subscriber.complete();
          teardown();
        }, CLOSE_ANIMATION_MS);
      };

      const closeSub: Subscription = ref.instance.close.subscribe((): void => close());

      return (): void => {
        closeSub.unsubscribe();
        teardown();
      };
    });
  }
}
